export const grade = {
	type: 'object',
	required: [
		'title',
		'programId',
		'number'
	],
	properties: {
		title: {
			type: 'string',
			minLength: 1
		},
		programId: {
			type: ['integer', 'string'],
			pattern: '^\\d+$'
		},
		number: {
			type: ['integer', 'string'],
			pattern: '^\\d+$'
		}
	},
	errorMessage: {
		required: 'validationFieldRequired',
		properties: {
			title: 'validationFieldRequired',
			programId: 'validationFieldRequired',
			number: 'validationFieldRequired'
		}
	}
};
